import userService from '../../services/users.service';

const state = () => ({
    userLogin: null,
    accessToken: null,
    accessValid: null,
    created: null,
    updated: null,
  });

const getters = {
    userLogin: state =>{
      return state.userLogin;
    }    
};

const mutations ={
    updateLogin: (state, login) => {
       state.userLogin = login;
    }
};

const actions ={
    updatePassword: async (payload) => {
          let response;
          response = await userService.updatePassword(payload);
          if (response.Status !== 'OK') {
             throw response.Mensagem;
          }
      },
};

export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions
};